import { useState, useEffect } from "react";
import API from '../../API';

const TypeExpert = ({changeTag}) => {

    const _api = new API()

    const [filter, setFilter] = useState([]);
	const [error, setError] = useState(null);
	const [isLoaded, setIsLoaded] = useState(false);

	useEffect(() => {
		_api.getFilters().then((result) => {
			setIsLoaded(true);
			setFilter(result['Предметная область']);
            
		},
		(error) => {
			setIsLoaded(true);
			setError(error);
		})
	},[])

    const [idFilter, setIdFilter] = useState([]);
    useEffect(()=>{
        changeTag(idFilter);
    },[idFilter])

    const [nameFilter, setNameFilter] = useState([]);

    function changeHandler(e){
        if  (!idFilter.includes(e.target.value)) {
            setIdFilter(idFilter => {return [...idFilter, e.target.value]})
            let item = filter.find(el  => el.id == e.target.value)
            setNameFilter(nameFilter => {return [...nameFilter, item.name]})
        }
    }

    function deleteTag(e){
        let item = filter.find(el  => el.name == e.target.attributes.getNamedItem('name').value)
        setIdFilter(idFilter => {
            return idFilter.filter(el => el != item.id)
        })
        setNameFilter(nameFilter => {
            return nameFilter.filter(el => el !== item.name)
        })
    }

    if (error) {
        return <div>Ошибка: {error.message}</div>;
    } else if (!isLoaded) {
        return <div>Загрузка...</div>;
    } else {
        return (
            <>
            <select className="add_expert-select" placeholder='Выберите' onChange={(e) => changeHandler(e)}>
                <option>Выберите</option>
                {filter.map(item => (
                    <option key={`idOption-${item.id}`} value={item.id} name={item.name}>
                        {item.name}

                    </option>
                ))}
            </select>
            {nameFilter.map(name => <p className="add_expert-filter" key={`keyOfOption-${name}`} name={name} onClick={(e)  => deleteTag(e)}>{name} <span>&times;</span></p>)}
            </>
        );
    }
}
export default TypeExpert;